import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { ModErrorComponent } from '../modals/mod-error/mod-error.component';
import { AccessService } from '../service/access.service';
import { SaaDelegateService } from '../service/saa-delegate.service';
import { ModalDelegateConfirmationComponent } from './modal-delegate-confirmation/modal-delegate-confirmation.component';
import { ModalDeleteDelegateComponent } from './modal-delete-delegate/modal-delete-delegate.component';
import { ModalEditDelegateComponent } from './modal-edit-delegate/modal-edit-delegate.component';

@Component({
  selector: 'app-saa-delegate',
  templateUrl: './saa-delegate.component.html',
  styleUrls: ['./saa-delegate.component.css']
})
export class SaaDelegateComponent implements OnInit {
  @ViewChild('paginator') paginator: MatPaginator;
  pageSizeOptions: any [] = [5, 10, 20];
  pageSize = 10;
  pageNumber = 1;
  totalPage: any [] = [];
  totalItems: number;


  personDelegateForm: UntypedFormGroup;
  personEditDelegateForm: UntypedFormGroup;
  submited = false;
  submitedEdit = false;
  todayDate: Date;
  minDateEnd: string;
  maxDate: any;
  delegatedList = [];
  editmodeMDM : string;

   //---people for mat autocomplete
   peoples=  [];
   searchPeople :string;
   personFound = false;
   personNotFound = false;

   //Filters
  peoplesFilterSeach= [];
  searchPeopleNameFilter:string;
  personFoundFilter = false;
  personNotFoundFilter = false;

   delegateMdmidF: string;
           // first datefilter
   datePeriodStartStartF: Date;
   datePeriodStartFinalF: Date;

             // second datefilter
   datePeriodEndStartF: Date;
   datePeriodEndFinalF: Date;

   order: string;
   baseReq: string;

//orders
   DateFromDesc = false
   DateToDesc = false

//MOCKK----------------------------------------
  mockDelegate = [
    {
      mdmid: "CB98123NC",
      fullName: "Damian Reyes" ,
      email: "damian.reyes@bhp.com",
      nationalId: "18950453-5",
      passport: null,
      dateStart: "2021-02-25",
      dateEnd: "2021-04-20"

    },

    {
      mdmid: "CB18723PP",
      fullName: "Luis Montenegro " ,
      email: "l.montenegro@bhp.com",
      nationalId: "20474283-5",
      passport: null,
      dateStart: "2021-06-14",
      dateEnd: "2021-04-12"
    }
  ]
  mockPeopleSearch = [
    {
      mdmid:	"786456",
      firstName:	"David",
      lastName:	"Portella",
      email:"damian.reyes@bhp.com"
    },
    {
      mdmid:	"1999-123",
      firstName:	"Damian",
      lastName:	"Reyes",
      email:"damian.reyes@bhp.com"
    },
    {
      mdmid:	"MDMID100",
      firstName:	"Ronald",
      lastName:	"Ruiz",
      email:	"qwertyu@bhp.com"
    }
  ]
  //--------------------------------------------
  constructor(private formBuilder: UntypedFormBuilder, private router: Router,
              private datePipe: DatePipe, private dataApi: SaaDelegateService,
              private dataApiAccess: AccessService,
              public dialog: MatDialog,private spinner: NgxSpinnerService) {
                this.order = '';
                this.baseReq = this.order;
                this.todayDate = new Date();
                this.maxDate = new Date((this.todayDate.getFullYear() +environment.MaxYeardateAccessForms), this.todayDate.getMonth(),this.todayDate.getDate());

  }

  ngOnInit() {
    this.personDelegateForm = this.formBuilder.group({
      mdmid: ['', Validators.required],
      fromDate: ['', Validators.required],
      toDate:['', Validators.required],
      dateIndefinite: false,
      searchPeople: ''
    });



    this.personEditDelegateForm = this.formBuilder.group({
      Id: ['', Validators.required],
      PeriodFrom: ['', Validators.required],
      PeriodTo:['', Validators.required],
      IsUndefined: false,
    });

    this.spinner.show("AccessValidation")
    this.dataApiAccess.getValidatePermision().subscribe(
      (data: any)=>{
        this.spinner.hide("AccessValidation");
        if(data) {
          this.getListDelegates()
        }else{
          //this.router.navigate(['/404']);
          //sessionStorage.clear();
          //window.location.reload();
         }
      },
      (err)=>{
        this.spinner.hide("AccessValidation");

        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',
          });
        }
      }
    )


    //this.getListDelegates();

    return
    this.delegatedList = this.mockDelegate;
  }

  getListDelegates(){
    this.spinner.show("loading");
    this.dataApi.getAllDelegates( this.pageNumber, this.pageSize, this.baseReq).subscribe(
      (dataResponse:any)=>{
        this.spinner.hide("loading");
        if(dataResponse==undefined || dataResponse == null){

          this.delegatedList = [];
        }else{
          this.pageNumber = dataResponse.paginator.page;
          this.pageSize = dataResponse.paginator.limit;
          this.totalPage = dataResponse.paginator.totalPages;
          this.totalItems = dataResponse.paginator.totalItems;
          this.delegatedList = dataResponse.items
        }

      },
      (err)=>{
        this.spinner.hide("loading");
        this.delegatedList = [];
        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',
          });
        }

      }
    );
  }


  handlePage(e: PageEvent) {
    this.pageSize = e.pageSize;
    this.pageNumber = e.pageIndex + 1;
    this.getListDelegates();
  }

  cleaninputDateUpdate(){
    this.personEditDelegateForm.controls.PeriodTo.setValue('')
    this.personEditDelegateForm.controls.IsUndefined.setValue(false)

  }
  cleaninputDatePost(){
    this.personDelegateForm.controls.toDate.setValue('')
  }

  changeLimitDatePost(){
    switch(this.personDelegateForm.controls['dateIndefinite'].value){
      case true:
        this.personDelegateForm.controls["toDate"].setValue(this.maxDate);
        break;
      case false:
        this.personDelegateForm.controls['toDate'].setValue("")
        break;
    }
 }
 changeLimitDateUpdate(){
    switch(this.personEditDelegateForm.controls['IsUndefined'].value){
      case true:
        this.personEditDelegateForm.controls["PeriodTo"].setValue(this.maxDate);
        break;
      case false:
        this.personEditDelegateForm.controls['PeriodTo'].setValue("")
        break;
    }
  }

  confirmEdit(){
    this.submitedEdit=true
    if(this.personEditDelegateForm.invalid){
      return;
    }
    this.dialog
    .open(ModalEditDelegateComponent, {
      panelClass: "myapp-no-padding-dialog",
    })
    .afterClosed()
    .subscribe((accept: boolean) => {
      if (accept) {
        let requestPayload = null;
        if(this.personEditDelegateForm.value.IsUndefined){
          requestPayload= {
            Id: this.personEditDelegateForm.value.Id,
            PeriodFrom : this.personEditDelegateForm.value.PeriodFrom,
            IsUndefined : this.personEditDelegateForm.value.IsUndefined
          }
        }else{
          requestPayload= {
            Id: this.personEditDelegateForm.value.Id,
            PeriodFrom : this.personEditDelegateForm.value.PeriodFrom,
            PeriodTo : this.personEditDelegateForm.value.PeriodTo,
            IsUndefined : this.personEditDelegateForm.value.IsUndefined
          }
        }
        this.spinner.show("loading");
        this.dataApi.updateDelegate(requestPayload).subscribe(
          (data:any)=>{
            this.getListDelegates();
            this.cancelEdit();
          },
          (err)=>{
            this.spinner.hide("loading");
            if(err.error.error !== 'Invalid token.') {
              this.dialog.open(ModErrorComponent, {
                width: 'auto',
                panelClass: 'myapp-no-padding-dialog',
              });
            }
          }
        );
      }
    }
    );
  }

  submitNewDelegate(){
    if(this.personDelegateForm.invalid){
      return;
    }
    this.dialog
      .open(ModalDelegateConfirmationComponent, {
        panelClass: "myapp-no-padding-dialog",
      })
      .afterClosed()
      .subscribe((accept: boolean) => {
        if (accept) {
        let requestPayload= {
          delegatedId: this.personDelegateForm.value.mdmid,
          periodFrom : this.personDelegateForm.value.fromDate,
          periodTo : this.personDelegateForm.value.toDate,
          isUndefined : this.personDelegateForm.value.dateIndefinite
        }
        this.spinner.show("loading");
        this.dataApi.postDelegate(requestPayload).subscribe(
          (data:any)=>{
            let personResponseMock = {
              name: data.fullname,
              email: data.email
            }
            this.spinner.hide("loading");
            this.router.navigate([
             "/saa-delegate-confirm"
           ], { queryParams: { name: personResponseMock.name, email: personResponseMock.email } });
          },
          (err)=>{
            this.spinner.hide("loading");
            if(err.error.error !== 'Invalid token.') {
              this.dialog.open(ModErrorComponent, {
                width: 'auto',
                panelClass: 'myapp-no-padding-dialog',
              });
            }
          }
        );
        }
      });
  }

  deleteDelegate(id){
    this.dialog
    .open(ModalDeleteDelegateComponent, {
      panelClass: "myapp-no-padding-dialog",
    })
    .afterClosed()
    .subscribe((accept: boolean) => {
      if (accept) {
        this.spinner.show("loading");
        this.dataApi.deleteDelegate(id).subscribe(
          ()=>{
            this.getListDelegates();
          },
          (err)=>{
            this.spinner.hide("loading");
            if(err.error.error !== 'Invalid token.') {
              this.dialog.open(ModErrorComponent, {
                width: 'auto',
                panelClass: 'myapp-no-padding-dialog',
              });
            }
          }
        );
      }}
    );


  }
  EditDelegate(person){
    this.personEditDelegateForm.controls.Id.setValue(person.detailDelegate.id)
    this.personEditDelegateForm.controls.PeriodFrom.setValue(person.detailDelegate.periodFrom)
    this.personEditDelegateForm.controls.PeriodTo.setValue(person.detailDelegate.periodTo)
    this.personEditDelegateForm.controls.IsUndefined.setValue(person.detailDelegate.isUndefined)
  }
  cancelEdit(){
    this.personEditDelegateForm = this.formBuilder.group({
      Id: ['', Validators.required],
      PeriodFrom: ['', Validators.required],
      PeriodTo:['', Validators.required],
      IsUndefined: false,
    });
  }


  // autocomplete methods

  searchPerson(event: Event){ // search person by letter
    this.personFound =true;
    this.personDelegateForm.controls.mdmid.setValue('');

    //----- Mock only testing-------
    // this.peoples = this.mockPeopleSearch;
    // return;
    //------------------------------
    const nameSearch = (event.target as HTMLInputElement).value;
    if(nameSearch!= ''){
      if(nameSearch.length<3){
        this.peoples= [];
        return
      }
      this.dataApi.getPersonSearch(nameSearch).subscribe(
        (data: any)=>{
          if(data==null || data==undefined){
            this.peoples= [];
          }else{
            this.peoples=  data;
          }
          //this.peoples=  [{name:"Damian Reyes", mdmid:"MDMID6598"}];
        },
        (err: any)=>{
          this.peoples= [];
        }
      );

      //this.peoples = this.mockPeopleSearch;
    }else{
      this.peoples= [];
    }
  }

  addpeopleMdmidFilterValue(option){
    this.personDelegateForm.controls.mdmid.setValue(option);
  }

  //Filterss


  clearFilter(){

    //clear order
    this.DateFromDesc = false
    this.DateToDesc = false
    this.order = '';

    // clear list + filters
    // this.maxDate = new Date();
    this.delegateMdmidF = null;
    this.searchPeopleNameFilter = null;
    this.datePeriodStartStartF = null;
    this.datePeriodStartFinalF = null;
    this.datePeriodEndStartF = null;
    this.datePeriodEndFinalF = null;
    this.peoplesFilterSeach = [];

    this.getalldelegateFilter();
  }
  peopleMdmidFilterUrlSetValue(option) {
    this.delegateMdmidF = option;
  }


  delegateIdFilter() {
    if (this.delegateMdmidF === '' || this.delegateMdmidF === null || this.delegateMdmidF === undefined) {
      return '';
    } else {
      return '&delegatedId=' + this.delegateMdmidF;
    }
  }

  DateRangeStartFilter(){
    // let anio = new Date();
    // anio.setFullYear(2099,12,31);
    // let aniofin = new Date();
    // aniofin.setFullYear(2009,12,31);

    // if(this.datePeriodStartFinalF===null || this.datePeriodStartFinalF===undefined)
    // {

    //   this.datePeriodStartFinalF = anio;
    // }

    // if(this.datePeriodStartStartF===null || this.datePeriodStartStartF===undefined)
    // {

    //   this.datePeriodStartStartF = aniofin;
    // }

    if(this.datePeriodStartStartF === null || this.datePeriodStartStartF === undefined ||
     this.datePeriodStartFinalF === null || this.datePeriodStartFinalF === undefined){
      return '';
    } else {
      return '&startDateFrom=' + this.transformDate(this.datePeriodStartStartF) + '&endDateFrom='+ this.transformDate(this.datePeriodStartFinalF);
    };
  }
  DateEndFilter(){
    // let anio = new Date();
    // anio.setFullYear(2099,12,31);
    // let aniofin = new Date();
    // aniofin.setFullYear(2009,12,31);

    // if(this.datePeriodEndFinalF===null || this.datePeriodEndFinalF===undefined)
    // {

    //   this.datePeriodEndFinalF = anio;
    // }

    // if(this.datePeriodEndStartF===null || this.datePeriodEndStartF===undefined)
    // {

    //   this.datePeriodEndStartF = aniofin;
    // }

    if(this.datePeriodEndStartF === null || this.datePeriodEndStartF === undefined ||
     this.datePeriodEndFinalF === null || this.datePeriodEndFinalF === undefined){
      return '';
    } else {
      return '&startDateTo=' + this.transformDate(this.datePeriodEndStartF) + '&endDateTo='+ this.transformDate(this.datePeriodEndFinalF);
    };
  }



  getalldelegateFilter() {
    this.baseReq=this.order + this.delegateIdFilter() + this.DateRangeStartFilter()+ this.DateEndFilter() ;
    this.applyFilter(this.baseReq);
  }


  applyFilter(filterUrl){ // new call get
    this.spinner.show("loading");
    this.paginator.firstPage();
    this.dataApi.getAllDelegates(this.pageNumber, this.pageSize, filterUrl
    ).subscribe((dataResponse: any) => {
      if(dataResponse ==null || dataResponse == undefined){
        this.delegatedList = []
        this.pageSize = 10;
        this.pageNumber = 1;
        this.totalItems = 0;
        this.totalPage = [];
      }else{
        this.delegatedList = dataResponse.items
        this.pageNumber = dataResponse.paginator.page;
        this.pageSize = dataResponse.paginator.limit;
        this.totalPage = dataResponse.paginator.totalPages;
        this.totalItems = dataResponse.paginator.totalItems;
      }

      this.spinner.hide("loading");
    }, (err) => {
      this.spinner.hide("loading");
      if(err.error.error !== 'Invalid token.') {
        this.dialog.open(ModErrorComponent, {
          width: 'auto',
          panelClass: 'myapp-no-padding-dialog',
        });
      }
     });
  }

  searchPersonFilter(event: Event){ // search person by letter for Filter
    this.personFoundFilter =true;
    this.personDelegateForm.controls.mdmid.setValue('');
    //----- Mock only testing-------
    //this.peoplesFilterSeach = this.mockPeopleSearch;

    const nameSearch = (event.target as HTMLInputElement).value;
    if(nameSearch!= ''){
      if(nameSearch.length<3){
        this.peoplesFilterSeach= [];
        return
      }
      this.dataApi.getPeropleSearchByletter(nameSearch).subscribe(
        (data: any)=>{
          if(data==null || data==undefined){
            this.peoplesFilterSeach= [];
          }else{
            this.peoplesFilterSeach=  data;
          }
          //this.peoples=  [{name:"Damian Reyes", mdmid:"MDMID6598"}];
        },
        (err: any)=>{
          this.peoplesFilterSeach= [];
        }
      );
    }else{
      this.peoplesFilterSeach= [];
    }
  }


  //order


  orderby(nameColumn, typeAsc){
    switch(nameColumn){
      case 'periodFrom': {
        this.DateFromDesc = !this.DateFromDesc;
        this.DateToDesc = false;
        break;
      }
      case 'periodTo':{
        this.DateFromDesc = false;
        this.DateToDesc =  !this.DateToDesc;
        break;
      }


    }
    const param = `&order_by=${nameColumn}&desc=${typeAsc}`;
    this.order = param;
    this.getalldelegateFilter();
  }


  //utility
  isrequired(atrr) {
    return this.personDelegateForm.controls[atrr].hasError("required");
  }
  transformDate(date: Date) {
    return (this.datePipe.transform(date, 'yyyy-MM-dd'));
  }



}
